import { Component, createRef } from 'react';
import { IFollowUpDonorForList } from '@nkr/models/index';
import { ICellRendererParams } from 'ag-grid-community';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { DonorAction } from '../donor-action';
import { menuItemList } from '../menu-item-list';

interface IProps {
    isAdmin: boolean,
    isAdminLogin: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: DonorAction) => void
}

export class ActionButtonRenderer extends Component<ICellRendererParams & IProps, {}> {
    myDropdown: any = createRef();

    componentDidMount = () => {
    }

    handleMenuToggle = (show: boolean) => {
        this.props.onMenuToggle(show);
    };

    handleMenuSelection = (id: any, action: number) => {
        this.props.onItemSelected(id, action);
    }

    getUrl = (action: DonorAction, id: number) => {
        let data = this.props.data as IFollowUpDonorForList;
        return null;
    }

    getMenuItems = () => {
        let data = this.props.data as IFollowUpDonorForList;

        let menuItems = [
            DonorAction.Edit
        ];

        return menuItems;
    }

    render = () => {
        const dataLength = this.props.api.getModel().getRowCount();
        const dropup = dataLength <= 18 ? false : this.props.rowIndex + 1 > dataLength - 6;

        const menuItems = this.getMenuItems().map(item => {
            return menuItemList.find(x => x.action == item);
        });

        const menu = menuItems.map(item => {
            let url = item.action != -1 ? this.getUrl(item.action, this.props.data.id) : null;
            let id = item.action >= 0 ? this.props.data.id : 'div-' + this.props.data.id + '-' + Math.random() * 10000;

            if (url == null) {
                if (item.action >= 0) {
                    return { id, action: item.action, include: true, selectable: true, element: <div style={{ width: 100 }}>{item.title}</div>, url: null };
                } else {
                    return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
                }
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a>, url, title: item.title };
            }
        });

        return (
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={this.handleMenuToggle}
                onSelect={this.handleMenuSelection}
            />
        );
    }
}